import React, {Component} from "react";
import {Link} from "react-router-dom";

class WorkGallery extends Component {
    render() {
        return (
            <section className="section work-gallery bg-cover" style={{backgroundImage: "url(assets/images/corrected_green_image.png)"}}>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-6 col-md-8 text-center">
                            <h2 className="section-heading h1 text-white mb-50">What We Service</h2>
                        </div>
                    </div>
                </div>
                <div className="carousel-fluid">
                    <div className="row no-gutters justify-content-center">
                        <div className="col-md-12">
                            <div className="owl-carousel fluid-carousel">
                                <div className="work-item" style={{ height: '300px' }}>
                                    <img className="img-fluid" style={{ height: '100%', objectFit: 'contain' }} src={process.env.PUBLIC_URL + '/assets/images/gallery/laptop-2.png'} alt="" />
                                    <Link to={'/pc-laptop-repair'} className="btn btn-sm btn-light initiate-scripts">Laptops</Link>
                                </div>
                                {/* work-item */}
                                <div className="work-item" style={{ height: '300px' }}>
                                    <img className="img-fluid" style={{ height: '100%', objectFit: 'contain' }} src={process.env.PUBLIC_URL + '/assets/images/gallery/macbook_resized.png'} alt="" />
                                    <Link to={"/pc-laptop-repair" } className="btn btn-sm btn-light initiate-scripts">Macs</Link>
                                </div>
                                {/* work-item */}
                                <div className="work-item" style={{ height: '300px' }}>
                                    <img className="img-fluid" style={{ height: '100%', objectFit: 'contain' }} src={process.env.PUBLIC_URL + '/assets/images/gallery/desktop-2.png'} alt="" />
                                    <Link to={'/pc-laptop-repair'} className="btn btn-sm btn-light initiate-scripts">Desktops</Link>
                                </div>
                                {/* work-item */}
                                <div className="work-item" style={{ height: '300px' }}>
                                    <img className="img-fluid" style={{ height: '100%', objectFit: 'contain' }} src={process.env.PUBLIC_URL + '/assets/images/gallery/iphone14.png'} alt="" />
                                    <Link to={'/mobile-repair'} className="btn btn-sm btn-light initiate-scripts">Smartphones</Link>
                                </div>
                                {/* work-item */}
                                <div className="work-item" style={{ height: '300px' }}>
                                    <img className="img-fluid" style={{ height: '100%', objectFit: 'contain' }} src={process.env.PUBLIC_URL + '/assets/images/gallery/oled.png'} alt="" />
                                    <Link to={'/game-repair'} className="btn btn-sm btn-light initiate-scripts">Game Consoles</Link>
                                </div>
                                {/* work-item */}
                               <div className="work-item" style={{ height: '300px' }}>
                                    <img className="img-fluid" style={{ height: '100%', objectFit: 'contain' }} src={process.env.PUBLIC_URL + '/assets/images/gallery/ipad.png'} alt="" />
                                    <Link to={'/mobile-repair'} className="btn btn-sm btn-light initiate-scripts">Tablets</Link>
                               </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default WorkGallery;